import { api } from "./api";

type FetchOverviewParams = {
  portfolio: string;
  quote_asset: string;
  window: number;
};

type FetchPositionSummaryParams = {
  portfolio: string;
  quote_asset: string;
};

export const portfolioApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch overview data for a portfolio
    fetchOverview: builder.query<any, FetchOverviewParams>({
      query: ({ portfolio, quote_asset, window }) =>
        `/api/portfolio/v1/overview?portfolio=${portfolio}&quote_asset=${quote_asset}${
          window ? `&window=${Math.floor(window)}` : ""
        }`,
    }),

    // Fetch position summary data for a portfolio
    fetchPositionSummary: builder.query<any, FetchPositionSummaryParams>({
      query: ({ portfolio, quote_asset }) =>
        `/api/portfolio/v1/position_summary?portfolio=${portfolio}&quote_asset=${quote_asset}`,
    }),

    // Fetch pricing assets
    fetchPricingAssets: builder.query<any, void>({
      query: () => `/api/portfolio/v1/pricing_assets`,
    }),
  }),
});

export const {
  useFetchOverviewQuery,
  useFetchPositionSummaryQuery,
  useFetchPricingAssetsQuery,
} = portfolioApi;
